import { AxiosResponse } from 'axios'
import { AttachmentsApi, MessagingApi } from 'conversations/api'
import { transformResponseIdToString } from 'conversations/utils/stringIdUtil'
import reduce from 'lodash/reduce'
import { PaginatedResponse } from 'shared/typings/api/PaginatedResponse'
import { Attachment } from 'shared/typings/conversations/Attachment'
import { Message, MessageWithId } from 'shared/typings/messages/Message'
import { MessageContentType } from 'shared/typings/messages/MessageContentType'
import { MessageType } from 'shared/typings/messages/MessageType'

const generateBulkFetchURL = (baseURL: string, ids: number[], paramName = 'id'): string => {
  return reduce(
    ids,
    function (urlAcc, id, index) {
      const urlToken = index === 0 ? '?' : '&'
      return `${urlAcc}${urlToken}${paramName}=${id}`
    },
    baseURL
  )
}

export const getFirstMessages = async (conversationId: number): Promise<MessageWithId[]> => {
  const res = await MessagingApi.get(`/conversations/${conversationId}/messages?limit=50`, {
    transformResponse: transformResponseIdToString('authorId'),
  })
  return res.data
}

export const fetchMessages = async (
  conversationId: number,
  limit: number,
  cursor?: string
): Promise<PaginatedResponse<MessageWithId>> => {
  const params = cursor ? { limit, from: cursor } : { limit }

  const res = await MessagingApi.get<PaginatedResponse<MessageWithId>>(
    `/conversations/${conversationId}/messages/page`,
    { params, transformResponse: transformResponseIdToString('authorId') }
  )
  return res.data
}

export const bulkMarkRead = (conversationId: number, messageIds: number[]): Promise<void> => {
  return MessagingApi.post('/messages/read-bulk', {
    conversationId,
    messageIds,
  })
}

export const fetchAttachments = async (ids: number[]): Promise<Attachment[]> => {
  const res = await AttachmentsApi.get<Attachment[]>(generateBulkFetchURL('/attachments', ids))
  return res.data
}

export interface MessagePayload {
  attachments?: number[]
  attributes?: {
    [key: string]: any
  }
  body?: string
  type: MessageType
  contentType?: MessageContentType
}

export const sendMessage = async (
  message: MessagePayload,
  conversationId: number
): Promise<MessageWithId> => {
  const res = await MessagingApi.post<Message, AxiosResponse<MessageWithId>>(
    `/conversations/${conversationId}/messages`,
    message
  )
  return res.data
}
